export const extractFileName = (filePath: string, grader?: string): string => {
  try {
    if (!grader) {
      const match = filePath.match(/[0-9a-f-]+-(.+?)_[0-9a-f-]+\.[a-zA-Z0-9]+$/);

      if (match && match[1]) {
        return match[1];
      }

      return 'Unknown File';
    }

    const graderIndex = filePath.indexOf(grader);
    if (graderIndex === -1) {
      return 'Unknown File';
    }

    const startIndex = graderIndex + grader.length + 1;

    const endIndex = filePath.indexOf('_', startIndex);

    if (endIndex !== -1) {
      return filePath.substring(startIndex, endIndex);
    } else {
      return filePath.substring(startIndex);
    }
  } catch (error) {
    return 'Unknown File';
  }
};